import * as React from 'react';
import { Anchor } from '../layout/Anchor';

export interface BaseProps {
    children?: any;
    className?: string;
    id?: string;
}

export function Grid(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'container ' + className;
    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export function Row(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'row ' + className;
    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export interface ColProps extends BaseProps {
    md?: number;
    sm?: number;
    xs?: number;
    mdOffset?: number;
    smOffset?: number;
    xsOffset?: number;
    centerText?: boolean;
}

export function Col(props: ColProps) {
    let classes = props.className !== undefined ? props.className : '';

    if (props.md !== undefined) {
        classes += ' col-md-' + props.md;
    }

    if (props.sm !== undefined) {
        classes += ' col-sm-' + props.sm;
    }

    if (props.xs !== undefined) {
        classes += ' col-xs-' + props.xs;
    }

    if (props.mdOffset !== undefined) {
        classes += ' col-md-offset-' + props.mdOffset;
    }

    if (props.smOffset !== undefined) {
        classes += ' col-sm-offset-' + props.smOffset;
    }

    if (props.xsOffset !== undefined) {
        classes += ' col-xs-offset-' + props.xsOffset;
    }

    if (props.centerText !== undefined && props.centerText) {
        classes += ' center';
    }

    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export function Nav(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = className + ' nav';

    return (
        <ul id={props.id} className={classes} role='menu'>
            {props.children}
        </ul>
    );
}

export interface NavItemProps extends BaseProps {
    text: string;
    href?: string;
    callback?: (e: any) => void;
}
export function NavItem(props: NavItemProps) {
    let className = props.className !== undefined ? props.className : '';
    let content;
    if (props.href !== undefined) {
        content = <Anchor href={props.href}>{props.text}</Anchor>;
    } else {
        content = props.text;
    }

    return (
        <li id={props.id} className={className} onClick={props.callback}>
            {content}
            {props.children}
        </li>
    );
}

// export interface SubNavProps extends BaseProps {
//     dataTarget: string;
//     text: string;
//     iconToggleShow: string;
//     iconToggleHide: string;
// }
// export function SubNav(props: SubNavProps) {
//     let className = props.className !== undefined ? props.className : '';
//     className = className + ' subNavListItem';
//     let dataTarget = '#' + props.dataTarget;

//     return (
//         <li id={props.id} className={className}>            
//             <a href='#' data-toggle='collapse' data-target={dataTarget} aria-expanded='false'>{props.text}</a>
//             <Icon className='navicon iconHide' name={props.iconToggleHide} />
//             <Icon className='navicon iconShow' name={props.iconToggleShow} /> 

//             <ul className='nav collapse' id={props.dataTarget} role='menu'>
//                 {props.children}
//             </ul>
//         </li>
//     );
// }

export function Navbar(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'navbar navbar-default ' + className;
    return (
        <nav id={props.id} className={classes}>
            <Grid>
                {props.children}
            </Grid>
        </nav>
    );
}

export function NavbarHeader(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'navbar-header ' + className;
    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export interface ButtonProps extends BaseProps {
    buttonType?: 'default' | 'primary' | 'secondary' | 'success' | 'danger' | 'info' | 'transparent' | 'section';
    buttonSize?: 'lg' | 'md' | 'sm' | 'xs';
    dataToggle?: string;
    ariaHaspopup?: boolean;
    ariaExpanded?: boolean;
    type?: string;
    onClick?: (e: any) => void;
    disabled?: boolean;
    dataTarget?: string;
    dataDismiss?: string;
}
export function Button(props: ButtonProps) {
    let type = 'button' as 'button' | 'submit' | 'reset';
    if (props.type != null) {
        type = props.type as 'button' | 'submit' | 'reset';
    }
    let buttonStyle = '';
    if (props.buttonType !== undefined) {
        buttonStyle = ' btn-' + props.buttonType;
    }
    if (props.buttonSize !== undefined) {
        buttonStyle += ' btn-' + props.buttonSize;
    }

    let className = props.className !== undefined ? props.className : '';
    let classes = 'btn' + buttonStyle + ' ' + className;

    let disabled = false;
    if (props.disabled != null && props.disabled === true) {
        disabled = true;
    }

    return (
        <button
            id={props.id}
            type={type}
            disabled={disabled}
            className={classes}
            data-toggle={props.dataToggle}
            aria-expanded={props.ariaExpanded}
            aria-haspopup={props.ariaHaspopup}
            onClick={props.onClick}
            data-target={props.dataTarget}
            data-dismiss={props.dataDismiss}
        >
            {props.children}
        </button>
    );
}

export interface DropdownButtonprops extends ButtonProps {
    title: any;
    noCaret?: boolean;
    disabled?: boolean;
}
export function DropdownButton(props: DropdownButtonprops) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'dropdown ' + className;
    let caret = (props.noCaret !== undefined && props.noCaret === false) ? <span className='caret' /> : '';
    return (
        <div className={classes} id={props.id}>
            <Button
                disabled={props.disabled}
                className='dropdown-toggle'
                buttonSize={props.buttonSize}
                type='button'
                buttonType={props.buttonType}
                dataToggle='dropdown'
                ariaHaspopup={true}
                ariaExpanded={false}
            >
                {props.title}
                {caret}
            </Button>
            <ul className='dropdown-menu'>
                {props.children}
            </ul>
        </div>
    );
}

export interface DropdownButtonItemProps extends BaseProps {    
    href: string;
    text?: string;
}

export function DropdownButtonItem(props: DropdownButtonItemProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'dropdown-item ' + className;
    
    return (
        <li className={classes} id={props.id}><Anchor href={props.href}>{props.text}</Anchor></li>
    );
}

export interface DropdownButtonItemCallbackProps extends BaseProps {
    onClick: (e: any) => void;
    text?: string;
}

export function DropdownButtonItemCallback(props: DropdownButtonItemCallbackProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'dropdown-item ' + className;
    return (
        <li className={classes} id={props.id} onClick={props.onClick}>
            <a>{props.text}</a>
        </li>
    );
}

export interface FormProps extends BaseProps {
    onSubmit: () => void;
}
export function Form(props: FormProps) {
    let className = props.className !== undefined ? props.className : '';
    const submit = (e: any) => {
        e.preventDefault();
        props.onSubmit();
    };
    return (
        <form id={props.id} className={className} onSubmit={submit}>
            {props.children}
        </form>
    );
}

export interface PanelProps extends BaseProps {
    header?: any;
    buttons?: any;
}
export function Panel(props: PanelProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'panel panel-default ' + className;
    let buttons = null;
    if (props.buttons !== undefined) {
        buttons = <div className='buttons'>{props.buttons}</div>;
    }

    return (
        <div id={props.id} className={classes}>
            {props.header != null &&
                <div className='panel-heading'>
                    {props.header}
                    {buttons}
                </div>
            }
            <div className='panel-body'>
                {props.children}
            </div>
        </div>
    );
}

export interface FormGroupProps extends BaseProps {
    bsSize?: 'lg' | 'sm';
    validationState?: 'success' | 'warning' | 'error' | 'null';
}
export function FormGroup(props: FormGroupProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'form-group ' + className;

    if (props.bsSize !== undefined) {
        classes += ' form-group-' + props.bsSize;
    }

    if (props.validationState !== undefined && props.validationState !== 'null') {
        classes += ' has-' + props.validationState;
    }

    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export function ControlLabel(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'control-label' + className;

    return (
        <label className={classes}>{props.children}</label>
    );
}

export interface FormControlProps extends BaseProps {
    type: 'text' | 'number' | 'email' | 'textarea' | 'password';
    value?: any;
    disabled?: boolean;
    placeholder?: string;
    name?: string;
    maxlength?: number;
    onChange?: (e: any) => void;
    onKeyPress?: (e: any) => void;
    autoFocus?: boolean;
    tooltip?: string;
}
export function FormControl(props: FormControlProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'form-control' + className;

    if (props.type === 'textarea') {
        return (
            <textarea
                id={props.id}
                name={props.name}
                className={classes}
                placeholder={props.placeholder}
                value={props.value}
                disabled={props.disabled}
                maxLength={props.maxlength}
                onChange={props.onChange}
                onKeyPress={props.onKeyPress}
                autoFocus={props.autoFocus}
                title={props.tooltip}
            >
                {props.value}
            </textarea>
        );
    } else {
        return (
            <input
                id={props.id}
                name={props.name}
                className={classes}
                type={props.type}
                placeholder={props.placeholder}
                value={props.value}
                disabled={props.disabled}
                maxLength={props.maxlength}
                onChange={props.onChange}
                onKeyPress={props.onKeyPress}
                autoFocus={props.autoFocus}
                title={props.tooltip}
            />
        );
    }
}

export interface SelectFormControlProps extends BaseProps {
    value?: string;
    disabled?: boolean;
    name?: string;
    label?: string;
    onChange?: (e: any) => void;
}
export function SelectFormControl(props: SelectFormControlProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'form-control ' + className;

    if (props.label !== undefined && props.label.length > 0) {
        return (
            <div className='select-wrapper'>
                <ControlLabel>{props.label}</ControlLabel>
                <select value={props.value} id={props.id} name={props.name} className={classes} disabled={props.disabled} onChange={props.onChange} >
                    {props.children}
                </select>
            </div>
        );
    } else {
        return (
            <select value={props.value} id={props.id} name={props.name} className={classes} disabled={props.disabled} onChange={props.onChange} >
                {props.children}
            </select>
        );
    }
}

export function HelpBlock(props: BaseProps) {
    let className = props.className !== undefined ? props.className : '';
    let classes = 'has-error ' + className;
    return (
        <div id={props.id} className={classes}>
            {props.children}
        </div>
    );
}

export interface PanelProps extends BaseProps {
    header?: any;
}
export function Accordion(props: PanelProps) {
    return (

        <div className='panel panel-default'>
            <div className='panel-heading'>
                <h4 className='panel-title'>
                    <a data-toggle='collapse' data-parent='#accordion' href='#collapse2'>
                        Collapsible Group 1</a>
                </h4>
            </div>
            <div id='collapse1' className='panel-collapse collapse'>
                <div className='panel-body'>Lorem ipsum dolor sit amet, consectetur adipisicing elit,
      sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
      minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat.</div>
            </div>
        </div>

        // <div className='panel panel-default'>
        //     <div className='panel-heading' id='headingOne'>
        //         <div className='collapsed' role='button' data-toggle='collapse' data-parent='#accordion' aria-expanded='false' aria-controls='collapseOne'>
        //             {props.header}
        //         </div>
        //     </div>
        //     <div id='collapseOne' className='panel-collapse collapse in' role='tabpanel' aria-labelledby='headingOne'>
        //         <div className='panel-body'>
        //             {props.children}
        //         </div>
        //     </div>
        // </div>

    );
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/bootstrap-components/BootstrapComponents.tsx